import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export interface CustomerData {
  name: string;
  nif: string;
  city?: string;
  street?: string;
  number?: string;
}

export interface GetCustomerDataQueryParams {
  user_id: number;
  company_id: number;
}

export class GetCustomerDataQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher
  ) { }

  async run(params: GetCustomerDataQueryParams): Promise<CustomerData> {
    let args = {
      user_id: params.user_id,
      company_id: params.company_id
    }
    try {
        const res = await this.dispatcher.dispatch('get.customer.data', args)
        return res as CustomerData
    } catch(error) {
      console.error('Error getting customer data', error)

      return {
        name: '',
        nif: '',
        city: '',
        street: '',
        number: ''
      }
    }
  }
}
